module.exports = __webpack_public_path__ + "static/media/1_A1_09.f23f1cf3.png";